
import places from '~/pages/_state/beaches'
export default places
